import type { FC, ReactElement, ReactNode } from "react"
import { memo } from "react"

import {
    type TLogoutFunction,
    type TScreenBreakpoints,
    type TUserState,
    useIsFakeParticipant,
    useLogout,
    useScreenBreakpoints,
    useUser
} from "@/3514/hooks"
import { type IAppState, type TAppDispatcher, useAppDispatcher, useAppSelector } from "@/3514/store/app"
import { buildCssClassName } from "@/3514/utils"
import { type TUseLogoNavigation, useLogoNavigation } from "@/hooks"
import ProductTypeLogo from "@/shared/ProductTypeLogo"
import type { TEmptyCallback } from "@/shared/types/functions"

import UserHeaderDropdown from "./UserHeaderDropdown"

interface IProps {
    header?: ReactElement | ReactNode | null
    withBurgerMenu?: boolean
    showLogo?: boolean
    fullWidth?: boolean
    _withoutLogo?: boolean
}

/**
 * @deprecated legacy stuff, rewrite A$AP
 */
const ParticipantLayoutHeader: FC<IProps> = ({
    header,
    withBurgerMenu = true,
    fullWidth = false,
    showLogo = true,
    _withoutLogo = false
}: IProps): ReactElement => {
    const { user }: TUserState = useUser()

    const isFakeParticipant: boolean = useIsFakeParticipant()

    const logout: TLogoutFunction = useLogout()
    const { isOpenBurgerMenu }: IAppState = useAppSelector()
    const { toggleBurgerMenu }: TAppDispatcher = useAppDispatcher()

    const breakpoints: TScreenBreakpoints = useScreenBreakpoints()

    const isMobile: boolean = breakpoints.xs || breakpoints.sm

    const handleLogout = e => {
        e.preventDefault()

        void logout({ keepLocalStorageAuthTokens: isFakeParticipant })
    }

    const { handleLogoNavigation }: TUseLogoNavigation = useLogoNavigation()

    const handleToggler: TEmptyCallback = (): void => toggleBurgerMenu()

    return (
        <div
            className={buildCssClassName("participant-layout-header", {
                "gray-bg": isOpenBurgerMenu,
                "w-100": fullWidth,
                "justify-content-between": fullWidth,
                "show-spacing": !!header,
                "fake-mode": isFakeParticipant
            })}
        >
            <div
                className={buildCssClassName("sidebar-menu__logo--mobile", {
                    "d-none": isOpenBurgerMenu || !isMobile || !showLogo,
                    "d-inline": fullWidth
                })}
            >
                {_withoutLogo ? null : <ProductTypeLogo handleLogoClick={handleLogoNavigation} />}
            </div>
            <div className={buildCssClassName("participant-layout-header-center", { "d-none": isOpenBurgerMenu })}>
                {header}
            </div>

            <UserHeaderDropdown handleLogout={handleLogout} user={user} showOnMobile={!isMobile} />

            {withBurgerMenu && isMobile && (
                <button
                    className={buildCssClassName("menu-hamburger ml-auto", { open: isOpenBurgerMenu })}
                    onClick={handleToggler}
                >
                    <span />
                    <span />
                    <span />
                </button>
            )}
        </div>
    )
}

export default memo(ParticipantLayoutHeader)
